<ng-container>
  <div class="block fixed top-4 right-4 z-[9999] overflow-y-auto max-h-[607px]">
    <div *ngFor="let alert of alertStack; index as i"
         class="flex items-center w-[332px] min-h-[71px] rounded-[10px] pe-[3.1rem] mb-4 relative"
         [ngClass]="getToastStyles(alert.variant)">

      <div class="mx-2">
        <img src="/assets/icons/ic_toast_{{alert.variant}}.svg" alt="logo" class="w-6">
      </div>

      <div class="my-3">
        <p class="text-base font-mSemiBold">{{ alert.title }}</p>
        <p class="text-sm text-primaryText font-mLight">{{ alert.description }}</p>
      </div>


      <div class="absolute right-4 cursor-pointer" (click)="closeAlert(alert.uid)">
        <img src="/assets/icons/ic_{{alert.variant}}_close_btn.svg" alt="close">
      </div>
    </div>
  </div>
</ng-container>
